import React from 'react';
import logo from './assets/logo_new.svg';

interface LogoProps {
  className?: string;
}

const Logo: React.FC<LogoProps> = ({ className }) => {
  return (
    <img 
      src={logo} 
      alt="Sisterhood Memberclub"
      className={className}
    />
  );
};

export default Logo;